/** Default tenant time zone (IANA). */
export const DEFAULT_IANA_TIME_ZONE = 'Europe/Budapest';

/** Legacy Windows IDs → IANA (seed / old tenants). */
const WINDOWS_TO_IANA: Record<string, string> = {
  'Central Europe Standard Time': 'Europe/Budapest',
  'Central European Standard Time': 'Europe/Budapest',
  'W. Europe Standard Time': 'Europe/Berlin',
  'GMT Standard Time': 'Europe/London',
  'UTC': 'Etc/UTC',
};

export function getIanaTimeZones(): string[] {
  try {
    const values = (Intl as any).supportedValuesOf?.('timeZone');
    if (Array.isArray(values) && values.length) {
      return [...values].sort((a, b) => a.localeCompare(b));
    }
  } catch {
    /* older engines */
  }
  return [DEFAULT_IANA_TIME_ZONE, 'Europe/Berlin', 'Europe/Vienna', 'UTC'];
}

/** Map Windows or empty values to IANA for form display / save. */
export function normalizeTimeZone(value: string | null | undefined): string {
  if (!value?.trim()) return DEFAULT_IANA_TIME_ZONE;
  const trimmed = value.trim();
  if (WINDOWS_TO_IANA[trimmed]) return WINDOWS_TO_IANA[trimmed];
  const zones = getIanaTimeZones();
  if (zones.includes(trimmed)) return trimmed;
  return trimmed;
}
